var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTick(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 19.085C14.501 19.085 18.5791 15.0068 18.5791 10.0059C18.5791 5.00488 14.501 0.926758 9.49121 0.926758C4.49023 0.926758 0.412109 5.00488 0.412109 10.0059C0.412109 15.0068 4.49902 19.085 9.5 19.085ZM8.59473 14.2861C8.1377 14.2861 7.76855 14.0576 7.46973 13.7148L5.65039 11.6143C5.39551 11.3154 5.30762 11.0781 5.30762 10.7793C5.30762 10.1289 5.85254 9.61914 6.49414 9.61914C6.86328 9.61914 7.12695 9.77734 7.37305 10.0498L8.58594 11.4297L11.5127 6.83301C11.8027 6.39355 12.1191 6.16504 12.5498 6.16504C13.1914 6.16504 13.7627 6.64844 13.7627 7.29004C13.7627 7.51855 13.6924 7.78223 13.5078 8.03711L9.69336 13.6797C9.42969 14.0488 9.02539 14.2861 8.59473 14.2861Z",
    fill: "#52DEB9"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick);
export default __webpack_public_path__ + "static/media/tick.fcde1cb89a3ab4d57799d890ddfa97dc.svg";
export { ForwardRef as ReactComponent };